export const InputThemesEnum = {
  Primary: {key: "theme-primary"},
  Default: {key: "theme-default"},
  Solid: {key: "theme-solid"},
  SolidV2: {key: "theme-solid-v2"},
  SolidV3: {key: "theme-solid-v3"},
  Dark: {key: "theme-dark"},
  Outline: {key: "theme-outline"},
  Underline: {key: "theme-underline"},
  UnderlineLight: {key: "theme-underline-light"},
  DefaultDark: {key: "theme-default-dark"},
  Transparent: {key: "theme-transparent"},
  Filled: {key: "theme-filled"},
  Header: {key: "theme-header"},
};
